module.exports = __webpack_public_path__ + "static/img/game_piroker.0ed485b.png";


//////////////////
// WEBPACK FOOTER
// ./static/fun/game_piroker.png
// module id = sVzd
// module chunks = 0